import React, {
    ChangeEvent,
    DetailedHTMLProps,
    InputHTMLAttributes,
    KeyboardEvent,
} from 'react';
import Icon, { IconKey } from './Icon';
import { twMerge } from 'tailwind-merge';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    iconKey?: IconKey;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onKeyUp?: (event: KeyboardEvent<HTMLInputElement>) => void;
    onFocus?: (
        event: DetailedHTMLProps<
            InputHTMLAttributes<HTMLInputElement>,
            HTMLInputElement
        >,
    ) => void;
    onBlur?: (
        event: DetailedHTMLProps<
            InputHTMLAttributes<HTMLInputElement>,
            HTMLInputElement
        >,
    ) => void;
}

const SearchInput = React.forwardRef<HTMLInputElement, Props>(
    (
        {
            id,
            className = '',
            type = 'text',
            iconKey,
            value,
            onBlur,
            onChange,
            onFocus,
            onKeyUp,
            autoFocus = false,
            ...props
        },
        ref,
    ) => {
        return (
            <div
                data-test-id="search-bar"
                className="relative w-full flex-1 rounded-sm"
            >
                <input
                    ref={ref}
                    type="search"
                    aria-label={props.placeholder}
                    value={value}
                    onChange={onChange}
                    onKeyUp={onKeyUp}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    className={twMerge(
                        'form-input focus-ring block size-10 w-full rounded-sm border-0 bg-gray-200 py-1.5 ps-10 text-sm/6 text-gray-600 placeholder:text-gray-400 focus:ring-0 dark:bg-gray-200 dark:placeholder:text-gray-500',
                        className,
                    )}
                    autoFocus={autoFocus}
                    {...props}
                />
                {iconKey ? (
                    <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-2">
                        <Icon iconKey={iconKey} className="text-gray-600" />
                    </div>
                ) : null}
            </div>
        );
    },
);

export default SearchInput;
